/**
 * Render desktop error handling page, supporting user re-try connection
 *@param onClose function, go back to last page
 *Other props can be passed depending on how to use this component
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Button} from '@stubhub/bamboo';

import CollapseIcon from '../icons/collapse/index';
import Speaker from '../icons/error-state';

import './index.scss';

const ErrorHandlingPage = ({onClose}) => {
  const backToTickets = <FormattedMessage id="error.handling.page.go.back" defaultMessage="Back to tickets" />;
  const firstMsg = (
    <FormattedMessage
      id="error.handling.page.first.msg"
      defaultMessage="Whoops! Something went wrong, and these tickets are not available right now."
    />
  );
  const actionButton = <FormattedMessage id="error.handling.page.browse" defaultMessage="Browse other tickets" />;

  return (
    <div className="EventRoyal__ErrorHandling">
      <button className="EventRoyal__ErrorHandling_return" onClick={onClose} type="button">
        <CollapseIcon />
        <span className="EventRoyal__ErrorHandling_return_text">{backToTickets}</span>
      </button>

      <div className="EventRoyal__ErrorHandling_body">
        <div className="EventRoyal__ErrorHandling_body_speaker">
          <Speaker />
        </div>

        <div className="EventRoyal__ErrorHandling_body_firstMsg">{firstMsg}</div>

        <div className="EventRoyal__ErrorHandling_body_button">
          <Button onClick={onClose}>{actionButton}</Button>
        </div>
      </div>
    </div>
  );
};

ErrorHandlingPage.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ErrorHandlingPage;
